module.exports = __webpack_public_path__ + "0b970eb98f81796c3d363774b4b0b6ef.mp3";